export const wrapLine = (line: string, maxWidth: number = 100): string => {
    if (line.length <= maxWidth) return line;

    const indentMatch = line.match(/^(\s*)/);
    const indent = indentMatch ? indentMatch[1] : '';
    const content = line.slice(indent.length);

    if (!content.trim() || content.startsWith('---')) return line;

    const words = content.split(' ');
    const lines: string[] = [];
    let currentLine = indent;

    for (const word of words) {
        const testLine =
            currentLine === indent
                ? currentLine + word
                : currentLine + ' ' + word;

        if (testLine.length <= maxWidth) {
            currentLine = testLine;
        } else {
            if (currentLine !== indent) {
                lines.push(currentLine);
            }
            currentLine = indent + '  ' + word;
        }
    }

    if (currentLine.trim()) {
        lines.push(currentLine);
    }

    return lines.join('\n');
};

export const stripHtml = (html: string): string => {
    if (!html) return '';
    let text = html;

    text = text.replace(/<hr\s*\/?>/gi, '\n---\n');
    text = text.replace(/<h3[^>]*>(.*?)<\/h3>/gi, '\n$1\n');
    text = text.replace(/<h4[^>]*>(.*?)<\/h4>/gi, '\n  $1\n');
    text = text.replace(/<\/?strong>/gi, '');
    text = text.replace(/<\/?b>/gi, '');
    text = text.replace(/<ul[^>]*>/gi, '\n');
    text = text.replace(/<\/ul>/gi, '');
    text = text.replace(/<ol[^>]*>/gi, '\n');
    text = text.replace(/<\/ol>/gi, '');
    text = text.replace(/<li[^>]*>/gi, '    • ');
    text = text.replace(/<\/li>/gi, '\n');
    text = text.replace(/<br\s*\/?>/gi, '\n');
    text = text.replace(/<\/p>/gi, '\n');
    text = text.replace(/<\/(div|tr)>/gi, '\n');
    text = text.replace(/<(p|div)[^>]*>/gi, '');
    text = text.replace(/<[^>]+>/g, '');

    text = text
        .replace(/&nbsp;/g, ' ')
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&apos;/g, "'");

    text = text.replace(/[ \t]+$/gm, '');
    text = text.replace(/^[ \t]+$/gm, '');
    text = text.replace(/\n{3,}/g, '\n\n');

    text = text
        .split('\n')
        .map((line) => wrapLine(line, 100))
        .join('\n');

    return text.trim();
};
